
(()=>{
 const initialized=new WeakSet(),instances=new Set();
 const reviews=[
  {name:'Claire M.',quote:'“…he finally feels respected at his own table.”'},
  {name:'Sarah D.',quote:'“…took away all my husband’s embarrassment.”'},
  {name:'Allison T.',quote:'“…actually belongs in a beautiful home.”'}
 ];
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 function init(stage){
  if(initialized.has(stage))return;initialized.add(stage);
  const events=new AbortController();let destroyed=false;
  function listen(target,type,fn){target.addEventListener(type,fn,{signal:events.signal});}
  let current=0,position=0,timer=0,frame=0,hover=false,focus=false,visible=false,busy=false;
  const cards=[...stage.querySelectorAll('.cr-review')];
  cards.forEach((card,i)=>listen(card,'click',()=>{const d=distance(i-current);if(d)move(d,true);}));
  function distance(n){return((n+1.5)%3+3)%3-1.5;}
  function draw(){
   const width=stage.clientWidth,cw=Math.min(196,Math.max(174,width*.64)),spread=(width-cw*.72)/2-5;
   cards.forEach((card,i)=>{
    const d=distance(i-position),a=Math.abs(d),s=1-.28*Math.min(a,1),fade=a<=1?1-.45*a:.55*(1-(a-1)*2);
    const x=Math.sign(d)*Math.min(a,1.3)*spread;
    card.style.width=cw+'px';card.style.transform='translate(-50%,-50%) translateX('+x+'px) scale('+s+')';
    card.style.opacity=Math.max(0,fade);card.style.zIndex=Math.round((2-a)*10);
   });
  }
  function paused(){return destroyed||hover||focus||!visible||document.hidden||reduced.matches;}
  function schedule(){clearTimeout(timer);if(!paused()&&!busy)timer=setTimeout(()=>move(1,false),3500);}
  function move(delta,manual){
   if(destroyed||(busy&&!manual))return;if(busy)cancelAnimationFrame(frame);clearTimeout(timer);busy=true;
   const start=position,target=current+delta,duration=reduced.matches?0:manual?320:550;let elapsed=0,last=0;
   function tick(t){
    if(!last)last=t;const dt=t-last;last=t;if(manual||!paused())elapsed+=dt;
    const p=duration?Math.min(1,elapsed/duration):1,ease=1-Math.pow(1-p,3);
    position=start+(target-start)*ease;draw();
    if(p<1){frame=requestAnimationFrame(tick);return;}
    current=((target%3)+3)%3;position=current;busy=false;draw();
    cards.forEach((c,i)=>c.setAttribute('aria-pressed',String(i===current)));
    if(!reduced.matches)cards[current].querySelector('.cr-stars').animate([{backgroundPosition:'100% 50%'},{backgroundPosition:'0% 50%'}],{duration:1100,easing:'linear'});
    schedule();
   }
   frame=requestAnimationFrame(tick);
  }
  listen(stage,'pointerenter',()=>{hover=true;clearTimeout(timer);});listen(stage,'pointerleave',()=>{hover=false;schedule();});
  listen(stage,'focusin',()=>{focus=true;clearTimeout(timer);});listen(stage,'focusout',e=>{if(!stage.contains(e.relatedTarget)){focus=false;schedule();}});
  listen(stage,'keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1,true);}});
  listen(document,'visibilitychange',schedule);
  listen(reduced,'change',()=>{if(reduced.matches&&busy){cancelAnimationFrame(frame);busy=false;position=current;draw();}schedule();});
  const resize=new ResizeObserver(draw);resize.observe(stage);
  const intersection=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.4});intersection.observe(stage);
  cards.forEach((c,i)=>c.setAttribute('aria-pressed',String(i===current)));draw();
  const instance={stage,destroy(){destroyed=true;events.abort();clearTimeout(timer);cancelAnimationFrame(frame);resize.disconnect();intersection.disconnect();instances.delete(instance);}};instances.add(instance);
 }
 function scan(){instances.forEach(i=>{if(!i.stage.isConnected)i.destroy();});document.querySelectorAll('#offers .cr-stage').forEach(init);}
 scan();const mount=document.getElementById('presteem-root');if(mount)new MutationObserver(scan).observe(mount,{childList:true,subtree:true});
})();
